if (document.getElementsByClassName("company-menu").length > 0) {
    console.log(document.getElementsByClassName("company-menu"))
	var stickyTop = jQuery(".company-menu").offset().top;
	var footer = jQuery(".footer").offset().top;
    console.log(footer)
	jQuery(window).on("scroll", function () {
		if (jQuery(window).scrollTop() >= stickyTop) {
			jQuery(".company-menu").addClass("sticky");
		} else {
			jQuery(".company-menu").removeClass("sticky");
		}
		if (jQuery(window).scrollTop() >= footer - 500) {
			jQuery(".company-menu").removeClass("sticky");
		}
	});
}
